import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  SwipeableDrawer,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import {
  ExpandMore,
  FiberManualRecord,
  FiberManualRecordOutlined,
} from "@mui/icons-material";
import { useQuickLinksItems } from "../../context/QuickLinksContext";

const MobileSidebarItem = ({ item, selectedTab, setSelectedTab, setSessionTab, isLast }) => (
  <ListItem disablePadding>
    <ListItemButton
      onClick={() => {
        setSelectedTab(item.id);
        if (item.id === "exchange") {
          setSessionTab("main");
        }
      }}
      sx={{
        mx: 2,
        borderBottom: isLast ? "none" : "1px solid #E6EBF0",
        "&:hover": { backgroundColor: "rgba(41, 64, 90, 0.04)" },
        borderRadius: "8px",
      }}
    >
      <ListItemIcon
        sx={{
          minWidth: "40px",
          color: selectedTab === item.id ? "#29405A" : "#33261D",
        }}
      >
        {selectedTab === item.id ? (
          <FiberManualRecord />
        ) : (
          <FiberManualRecordOutlined />
        )}
      </ListItemIcon>
      <ListItemText
        primary={
          <Typography
            sx={{
              fontFamily: "'Quicksand', sans-serif",
              fontWeight: selectedTab === item.id ? 700 : 500,
              fontSize: "13px",
              color: selectedTab === item.id ? "#29405A" : "#33261D",
              letterSpacing: "0.2px",
            }}
          >
            {item.name}
          </Typography>
        }
      />
    </ListItemButton>
  </ListItem>
);

const MobileSidebar = ({ open, toggleSidebar, sidebarData, isProfilePage }) => {
  const { setSessionTab, setSelectedTab, selectedTab, primaryTabs, secondaryTabs } =
    useQuickLinksItems();
  const [expanded, setExpanded] = useState(true);

  return (
    <SwipeableDrawer
      anchor="left"
      open={open}
      onClose={toggleSidebar}
      onOpen={toggleSidebar}
      PaperProps={{
        sx: {
          backgroundColor: "#F5F3ED",
        },
      }}
    >
      <Box
        sx={{
          width: 250,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100%",
        }}
        role="presentation"
      >
        <List>
          <img
            src={require("../../assets/images/full_logo.png")}
            alt=""
            style={{
              margin: "15px 20px",
              height: "50px",
              width: "auto",
            }}
            onClick={() => {
              setSelectedTab("home");
              toggleSidebar();
            }}
          />

          {/* ── Primary Navigation ── */}
          {primaryTabs?.map((item, index) => (
            <Box key={item.id} onClick={toggleSidebar}>
              <MobileSidebarItem
                item={item}
                selectedTab={selectedTab}
                setSelectedTab={setSelectedTab}
                setSessionTab={setSessionTab}
                isLast={index === primaryTabs.length - 1}
              />
            </Box>
          ))}

          {/* ── Secondary: Learning & Resources (collapsible) ── */}
          {secondaryTabs?.length > 0 && (
            <Accordion
              expanded={expanded}
              onChange={() => setExpanded((prev) => !prev)}
              disableGutters
              elevation={0}
              sx={{
                backgroundColor: "transparent",
                "&:before": { display: "none" },
                borderTop: "1px solid #E6EBF0",
                mx: 1,
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMore sx={{ color: "#29405A" }} />}
                sx={{
                  minHeight: "44px",
                  px: 1,
                  "& .MuiAccordionSummary-content": {
                    my: "8px",
                  },
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "'Quicksand', sans-serif",
                    fontWeight: 700,
                    fontSize: "12px",
                    color: "#29405A",
                    textTransform: "uppercase",
                    letterSpacing: "0.8px",
                  }}
                >
                  Learning & Resources
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ p: 0 }}>
                <List disablePadding>
                  {secondaryTabs?.map((item, index) => (
                    <Box key={item.id} onClick={toggleSidebar}>
                      <MobileSidebarItem
                        item={item}
                        selectedTab={selectedTab}
                        setSelectedTab={setSelectedTab}
                        setSessionTab={setSessionTab}
                        isLast={index === secondaryTabs.length - 1}
                      />
                    </Box>
                  ))}
                </List>
              </AccordionDetails>
            </Accordion>
          )}
        </List>
      </Box>
    </SwipeableDrawer>
  );
};

export default MobileSidebar;
